import { makeFilterString } from "../utils/Helper";
import {
  GetMeritApiLogDetailsSuccess,
  GetMeritApiLogsSuccess,
  GetMeritOrderDetailsSuccess,
  GetMeritOrdersSuccess,
  MeritLoading,
} from "./Action";
import { reduxRequest } from "common/utils/reduxRequest";

export const getMeritOrdersRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: MeritLoading,
    loadingType: "list orders",
    successFunction: GetMeritOrdersSuccess,
    url: `/admin/merit/orders${makeFilterString(variables?.params)}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getMeritOrderDetailsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: MeritLoading,
    loadingType: "order details",
    successFunction: GetMeritOrderDetailsSuccess,
    url: `/admin/merit/orders/${variables?.id}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getMeritApiLogsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: MeritLoading,
    loadingType: "list api logs",
    successFunction: GetMeritApiLogsSuccess,
    url: `/admin/merit/api_logs${makeFilterString(variables?.params)}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getMeritApiLogDetailsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: MeritLoading,
    loadingType: "api log details",
    successFunction: GetMeritApiLogDetailsSuccess,
    url: `/admin/merit/api_logs/${variables?.id}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export * from "./Action";
export * from "./Reducer";
